import React, { useState, useEffect } from 'react';
import 'react-phone-input-2/lib/style.css'
import { Link, useLocation } from 'react-router-dom';
import { format } from "date-fns";
import Select from "react-select";
import * as textMessage from "../../../Config/Constant";
import redCross from "../../../assets/images/CommonComponent/redCross.svg";
import calendarIcon from '../../../assets/images/CommonComponent/calendarIcon.png';
import greenPlus from '../../../assets/images/CommonComponent/greenPlus.svg';
import historyIcon from '../../../assets/images/CommonComponent/history.svg';
import AppContainer from '../../../components/AppContainer/AppContainer';
import { useNavigate } from 'react-router-dom';
import { updateActivity, viewActivityDetails } from '../../../redux/actions/MasterDataAction/ActivityAction/ActivityAction';
import { getUserRoleList } from '../../../redux/actions/UserManagementAction/TeamMembersAction/TeamMembersAction';
import { useSelector, useDispatch } from 'react-redux';
import { createNotification } from '../../../Config/NotificationToast';
import * as moment from 'moment';
import {
    durationOptions, frequencyOptions, parseJSON, weekdays
} from '../../../utils/Helper';
import './EditActivity.scss';
import { FormControl, FormControlLabel, Radio, RadioGroup, Checkbox, CircularProgress } from '@mui/material';
import { EDIT_ACTIVITY } from '../../../Router/RoutesURL';
import Modal from 'react-bootstrap/Modal';
import CrossIcon from '../../../assets/images/CommonComponent/CrossIcon.svg'
import DatePicker from '../../../components/DatePicker/DatePicker';

const AddActivity = (props) => {
    const { history } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const location = useLocation();
    const { activityId } = location.state;
    const [title, setTitle] = useState('');
    const [selectedDuration, setSelectedDuration] = useState('');
    const [venue, setVenue] = useState('');
    const [capacity, setCapacity] = useState();
    const [date, setDate] = useState('');
    const [stopDate, setStopDate] = useState('');
    const [newStopDate, setNewStopDate] = useState('');
    const [selectedTime, setSelectedTime] = useState("00:00:00");
    const [notes, setNotes] = useState('');
    const [showBtns, setShowBtns] = useState(false);
    const [repeatActivity, setRepeatActivity] = useState(false);
    const [selectedFrequency, setSelectedFrequency] = useState(null);
    const [selectedDays, setSelectedDays] = useState(weekdays);
    const {loading} = useSelector(state => state?.viewActivityDetails);
    const viewActivityDataRes = useSelector(state => state?.viewActivityDetails?.viewActivityDetails?.data);
    const updateActivityReducer = useSelector(state => state?.updateActivity);
    const [updateKey, setUpdateKey] = useState(0);
    const [isPermanent, setIsPermanent] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);

    const customStyles = {
        singleValue: (provided, state) => ({
            ...provided,
            fontWeight: 400
        }),
    };

    useEffect(() => {
        const sendRequest = {
            "pageNo": 1,
            "pageSize": "",
        }
        dispatch(getUserRoleList(sendRequest));
    }, []);

    useEffect(() => {
        const sendRequest = {
            "activity_id": activityId
        };
        dispatch(viewActivityDetails(sendRequest));
        setShowModal(false)
        setUpdateKey(0)
    }, [location.state]);

    useEffect(() => {
        let previousFreq = parseJSON(viewActivityDataRes?.frequency)
        let isDataChanged = viewActivityDataRes &&  (title !== viewActivityDataRes?.title
            || venue !== viewActivityDataRes?.venue
            || capacity !== viewActivityDataRes?.no_of_capacity
            || selectedTime !== moment(viewActivityDataRes?.activity_datetime).format('HH:mm:ss')
            || date !== moment(viewActivityDataRes?.activity_datetime).format('DD/MM/YYYY')
            || notes !== viewActivityDataRes?.notes
            || JSON.stringify(selectedDuration) !== JSON.stringify({ value: viewActivityDataRes?.duration, label: `${viewActivityDataRes?.duration} Minutes` })
            || repeatActivity !== !!parseInt(viewActivityDataRes?.is_repeated)
            || (selectedFrequency && selectedFrequency?.value !== previousFreq?.key)
            || (previousFreq?.key==='weekly' ? JSON.stringify(selectedDays) !== JSON.stringify(previousFreq?.value) : false)
            || isPermanent !== !viewActivityDataRes?.stop_activity_date
            || (viewActivityDataRes?.stop_activity_date ? moment(viewActivityDataRes?.stop_activity_date).format('DD/MM/YYYY'): '') !== stopDate
        )

            if (isDataChanged && title !== "" && venue !== "" && capacity !== "" && selectedTime !== "" && date !== "" && notes !== "" && selectedDuration !== "") {
                if(repeatActivity){
                    const isWeekly = selectedFrequency?.value === 'weekly';
                    const hasWeeklyDays = selectedDays?.some(item => item.value === 1);
                    const hasStop = isPermanent || stopDate;
    
                    if ((selectedFrequency && !isWeekly && hasStop) ||(isWeekly && hasWeeklyDays && hasStop)) {
                        setShowBtns(true);
                    } else {
                        setShowBtns(false);
                    }
                }else{
                    setShowBtns(true);
                }
            } else {
                setShowBtns(false);
            }
        }, [title, venue, capacity, selectedTime, date, notes, selectedDuration, selectedDays, repeatActivity, selectedFrequency, stopDate, isPermanent])
    

    useEffect(() => {
        if (viewActivityDataRes) {
            setTitle(viewActivityDataRes?.title);
            setVenue(viewActivityDataRes?.venue);
            setCapacity(viewActivityDataRes?.no_of_capacity);
            setDate(moment(viewActivityDataRes?.activity_datetime).format('DD/MM/YYYY'));
            setStopDate(viewActivityDataRes?.stop_activity_date ? moment(viewActivityDataRes?.stop_activity_date).format('DD/MM/YYYY'): '');
            setNewStopDate(viewActivityDataRes?.stop_activity_date ? moment(viewActivityDataRes?.stop_activity_date).format('DD/MM/YYYY'): '');
            setIsPermanent(!viewActivityDataRes?.stop_activity_date)
            setSelectedTime(moment(viewActivityDataRes?.activity_datetime).format('HH:mm:ss'))
            setNotes(viewActivityDataRes?.notes);
            setSelectedDuration({ value: viewActivityDataRes?.duration, label: `${viewActivityDataRes.duration} Minutes` });
            setRepeatActivity(viewActivityDataRes?.is_repeated && !!parseInt(viewActivityDataRes?.is_repeated))
            let frequency = viewActivityDataRes?.frequency && JSON.parse(viewActivityDataRes?.frequency)
            setSelectedFrequency(frequencyOptions?.filter((item)=> item.value === frequency?.key)?.[0])
            setSelectedDays(frequency?.key === 'weekly' ? frequency?.value :  weekdays)
        }
    }, [viewActivityDataRes])

    const cancelSubmit = () => {
        navigate(-1)
    };

    const submitData = () => {
        const validEmail = textMessage.PHONE_REGEX;
        if (!validEmail.test(capacity)) {
            createNotification('warning', 'Capacity must be Number*');
            return false;
        }else if (!viewActivityDataRes.repeat_ref_id && viewActivityDataRes.is_repeated==='0'){
            handleUpdate(0)
        }
        else{
            setShowModal(true)
        }
    }

    const handleUpdate = (type)=>{

        const dateObje = moment(date, 'DD/MM/YYYY').format('yyyy-MM-DD');
        const dateTimeString = `${dateObje}T${selectedTime}`;
        const localDate = new Date(dateTimeString);
        const utcDate = localDate.toISOString().split('T')[0]; // UTC date in format "YYYY-MM-DD"
        const utcTime = localDate.toISOString().split('T')[1].slice(0, 8); // UTC time in format "HH:mm:ss"

        let frequency = selectedFrequency?.value === 'daily' 
            ? {"key" : "daily",  "value" : ""}
            : selectedFrequency?.value === 'weekly'
                ? {"key" : "weekly",  "value" : [...selectedDays]}
                : selectedFrequency?.value === 'monthly'
                    ? {"key" : "monthly",  "value" : utcDate + " " + utcTime}
                    :null

        const sendRequest = {
            "id": activityId,
            "title": title,
            "notes": notes,
            "activity_datetime": utcDate + " " + utcTime,
            "end_date": repeatActivity && !isPermanent ? moment(stopDate, "DD/MM/YYYY").format("YYYY-MM-DD") : '',
            "venue": venue,
            "no_of_capacity": Number(capacity),
            "duration": selectedDuration?.value,
            "is_repeated": + repeatActivity,
            "frequency": repeatActivity ? JSON.stringify(frequency) : "",
            "update_all" : type,
            "repeat_ref_id": viewActivityDataRes.repeat_ref_id || activityId,
            onSuccessCallback: ()=>{
                navigate(-1);
            }
        };
        dispatch(updateActivity(sendRequest));
        setShowModal(false)
        setUpdateKey(0)
    }

    const handleChange = (val) => {
        setSelectedDuration(val)
    }

    const handleFrequencyChange = (val)=>{
        setSelectedDays(weekdays)   
        setSelectedFrequency(val)
    }

    const handleSelectDays = (e)=>{
        setSelectedDays((prev)=>{
            let d = JSON.parse(JSON.stringify(prev))
            d.forEach(item=>{
                if(item.day===e.target.value){
                    item.value= e.target.checked ? 1: 0
                }
            })
            return d
        })
    }

    const handleChangeCapacity = (val) => {
        const regexName = textMessage.PHONE_REGEX;
        const nameFormat = regexName.test(val);
        if (val === "") {
            setCapacity(val);
        } else if (nameFormat && val.length < 12) {
            setCapacity(val);
        }
    }

    const handleChangeStartDate = (val) => {
        // const formattedDate = format(val, "yyyy-MM-dd");
        setDate(format(val, 'dd/MM/yyyy'));
        if (stopDate && moment(val).isAfter(moment(stopDate, 'DD/MM/YYYY'))) {
            setStopDate('');
          }
    }

    const handleChangeStopDate = (val) => {
        const formattedDate = format(val, "dd/MM/yyyy");
        setNewStopDate(formattedDate)

        if(viewActivityDataRes?.lastly_added_booking && new Date(viewActivityDataRes?.lastly_added_booking) > val){
            setShowAlertModal(true)
        }else{
            setStopDate(formattedDate)
        }
    }

    const SetTime = (date) => {
        setSelectedTime(moment(date).format("HH:mm:ss"));
    }

    const handleRepeatActivity = (e)=>{
        setRepeatActivity((prev)=> !prev)
        if(!e.target.checked){
            setIsPermanent(false);
            setStopDate('');
            setSelectedFrequency(null)
            setSelectedDays(weekdays)
        }
    }

    const handleIsPermanent = (e)=>{
        setIsPermanent((prev)=> !prev)
        if(e.target.checked){
            setStopDate('');
        }
    }

    const visitMasterActivity = ()=>{
        navigate(EDIT_ACTIVITY, {state: {activityId: viewActivityDataRes?.repeat_ref_id}})
    }

    return (
        <AppContainer history={history}>
            <div className="event-content">
                <div className='edit-activity'>
                    {   
                        loading && 
                        <div className='loader'>
                            <CircularProgress sx={{'color': '#74613C'}}/>
                        </div>
                    }
                    {
                        !loading && viewActivityDataRes
                        &&
                        <div className="card">
                            <div className="card-header">
                                <h4 className='mb-0'>Edit Activity  </h4>
                                {
                                    showBtns &&
                                    <div className=''>
                                        <button type="button" className="btn btn-danger redButton mr-3" onClick={cancelSubmit}>
                                            <img className="mainIcon mr-2" src={redCross} alt="" width="16px" height="16px" />
                                            CANCEL</button>

                                        <button type="submit" className="btn btn-success greenButton" onClick={submitData}>
                                                {
                                                    updateActivityReducer.loading ?
                                                    <>
                                                        <CircularProgress size={30} sx={{'color': '#83C52B'}}/>
                                                    </>
                                                    :
                                                    <>
                                                        <img className="mainIcon mr-2" src={greenPlus} alt="" width="16px" height="16px" /> UPDATE
                                                    </>
                                                }
                                            </button>
                                    </div>
                                }
                            </div>
                            <div className="separator"></div>
                            <div className="card-body ">
                                <div className='row cardDiv'>
                                    <div className='col'>
                                        <div className='row'>
                                            <div className='col-4 mb-3'>
                                                <div className=" pr-0">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label Label">Title*</label>
                                                    <input
                                                        className="form-control Title"
                                                        type="text"
                                                        value={title}
                                                        placeholder="Enter title"
                                                        onChange={(e) => { setTitle(e.target.value) }}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-4'>
                                                <div className="">
                                                    <div className="mb-3 pr-0">
                                                        <label htmlFor="exampleFormControlInput1" className="form-label Label">Venue*</label>
                                                        <input
                                                            className="form-control Title"
                                                            type="text"
                                                            placeholder="Enter venue"
                                                            value={venue}
                                                            onChange={(e) => { setVenue(e.target.value) }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-4'>
                                                <div className=" pr-0">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label Label">Capacity*</label>
                                                    <div className="mb-3 pr-0 d-flex phoneNoInput">
                                                        <input
                                                            className="form-control Title"
                                                            type="text"
                                                            placeholder="Enter capacity"
                                                            value={capacity}
                                                            onChange={(event) => handleChangeCapacity(event.target.value)}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='row mb-3'>
                                            <div className='col-4'>
                                                <div className="w-100 pr-0  activity-date-div">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label Label">Start Date*</label>
                                                    <DatePicker
                                                        onChange={date => { handleChangeStartDate(date) }}
                                                        showMonthDropdown={true}
                                                        showYearDropdown={true}
                                                        value={!date ? '' : new Date( moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD'))}
                                                        minDate={new Date()}
                                                        width={'350px'}
                                                        height={'48px'}
                                                    />
                                                </div>
                                            </div>
                                            
                                            <div className='col-4 '>
                                                {
                                                    viewActivityDataRes?.repeat_ref_id ? 
                                                    <> <div className='visit-master-link h-100 d-flex align-items-end pb-1' onClick={visitMasterActivity} > <span>View Master Activity</span> </div> </>
                                                    :
                                                    <div className='d-flex align-items-end h-100'>
                                                        <div className='d-flex align-items-center'>
                                                            <Checkbox
                                                            checked={repeatActivity}
                                                            onChange={handleRepeatActivity}
                                                            inputProps={{ 'aria-label': 'controlled' }}
                                                            size="small"
                                                                sx={{
                                                                    color: "#74613C",
                                                                    '&.Mui-checked': {
                                                                    color: "#74613C",
                                                                    },
                                                                }}
                                                                />
                                                            <div>Repeat activity</div>
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                            {
                                                !viewActivityDataRes?.repeat_ref_id &&
                                                <div className='col-4'>
                                                    <div className='d-flex align-items-end h-100'>
                                                        <div className='d-flex align-items-center '>
                                                            <div>
                                                                <Checkbox
                                                                checked={isPermanent}
                                                                onChange={handleIsPermanent}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                                size="small"
                                                                disabled={!repeatActivity}
                                                                    />
                                                            </div>
                                                            <div>Is Permanent</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        {
                                            (!viewActivityDataRes?.repeat_ref_id) &&
                                            <div className='row mb-3'>
                                                <div className='col-4'>
                                                    <div className={`w-100 pr-0  activity-date-div  ${viewActivityDataRes?.repeat_ref_id ? 'opacity-50': ''}`}>
                                                        <label htmlFor="exampleFormControlInput1" className="form-label Label">Stop Date*</label>
                                                        <DatePicker
                                                            onChange={date => { handleChangeStopDate(date) }}
                                                            showMonthDropdown={true}
                                                            showYearDropdown={true}
                                                            value={!stopDate ? '' : new Date( moment(stopDate, 'DD/MM/YYYY').format('YYYY-MM-DD'))}
                                                            {...(date && {minDate: new Date( moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD'))})}
                                                            width={'350px'}
                                                            height={'48px'}
                                                            disabled={!date || !repeatActivity || isPermanent}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-4'>
                                                    <div className="pr-0 mb-3">
                                                        <label htmlFor="frequency" className="form-label Label">Frequency*</label>
                                                        <div className={`frequencyBlock w-100  ${repeatActivity ? '': 'opacity-50'}`}>
                                                            <Select
                                                                isDisabled={!repeatActivity}
                                                                placeholder="Select"
                                                                className="react-select"
                                                                classNamePrefix="react-select"
                                                                onChange={handleFrequencyChange}
                                                                value={selectedFrequency}
                                                                options={frequencyOptions}
                                                                styles={customStyles}
                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    isFocused: "#74613C",
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#F5F5F5',
                                                                        primary: '#74613C',
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-4'>
                                                    <div className="d-flex align-items-end">
                                                        <div className="pt-5 pr-0">
                                                            {
                                                                selectedFrequency?.value === "weekly" && 
                                                                    <div className='weekly-frequency'>
                                                                        <div className={`check-box-input d-flex ${repeatActivity ? '' : 'disabled'}`}>
                                                                            {
                                                                                weekdays?.length && weekdays.map((item, index)=>(
                                                                                    <div className="check-box" key={index}>
                                                                                        <input type="checkbox" name='day' value={item.day} 
                                                                                            checked={selectedDays.filter(e => e.day === item.day)[0].value}
                                                                                            onChange={(e)=>{handleSelectDays(e, item)}}
                                                                                            disabled={!repeatActivity}
                                                                                        />
                                                                                        <label htmlFor={item.day}> {item.day}</label>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        <div className='row mb-3'>
                                            <div className='col-4'>
                                                <div className="mb-3 pr-0">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label Label">Time*</label>
                                                    <DatePicker
                                                        showTimeSelect={true}
                                                        showTimeSelectOnly={true}
                                                        onChange={date => { SetTime(date) }}
                                                        showMonthDropdown={true}
                                                        showYearDropdown={true}
                                                        value={selectedTime ? moment(selectedTime, 'HH:mm:ss').toDate() : ''}
                                                        width={'350px'}
                                                        height={'48px'}
                                                        placeholder={'Select time'}
                                                        timeFormat={"HH:mm"}
                                                        timeIntervals={15}
                                                        timeCaption="Hour"
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-4'>
                                                <div className="mb-3 d-flex">
                                                    <div className="mb-3 pr-0 w-100">
                                                        <label htmlFor="exampleFormControlInput1" className="form-label Label">Duration*</label>
                                                        <div className='durationBlock'>
                                                            <Select
                                                                placeholder="Duration"
                                                                className="react-select"
                                                                classNamePrefix="react-select"
                                                                onChange={handleChange}
                                                                value={selectedDuration}
                                                                options={durationOptions}
                                                                styles={customStyles}

                                                                theme={(theme) => ({
                                                                    ...theme,
                                                                    isFocused: "#74613C",
                                                                    colors: {
                                                                        ...theme.colors,
                                                                        primary25: '#F5F5F5',
                                                                        primary: '#74613C',
                                                                    },
                                                                })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className="mb-3 pr-0">
                                                <label htmlFor="exampleFormControlInput1" className="form-label Label">Notes*</label>
                                                <textarea className="form-control textArea" id="exampleFormControlTextarea1" rows="3" placeholder="Enter notes"
                                                    value={notes}
                                                    onChange={(e) => { setNotes(e.target.value) }}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {showModal && <UpdateModal showModal={showModal} setShowModal={setShowModal} updateKey={updateKey} handleUpdate={handleUpdate} setUpdateKey={setUpdateKey} />}
                    {showAlertModal && <AlertModal showModal={showAlertModal} setShowModal={setShowAlertModal} onOk={()=>setStopDate(newStopDate)} />}
                </div>
            </div >
        </AppContainer >
    )
}
export default AddActivity


export const UpdateModal = ({showModal, setShowModal, handleUpdate, updateKey, setUpdateKey}) =>{
    return (
        <Modal centered className="edit-activity-modal br-8" show={showModal} onHide={() => { setUpdateKey(0); setShowModal(false) }}>
                <Modal.Header className='w-100'>
                    <div className='d-flex position-relative justify-content-center w-100'>
                        <div className="modalText pb-4">Update Activity</div>
                        <div className="cross--icon position-absolute" style={{right: '15px'}} onClick={() => { setUpdateKey(0); setShowModal(false) }}><img src={CrossIcon}/></div>
                    </div>
                </Modal.Header>
                <Modal.Body className='pt-2 float-start'>
                    <div style={{marginLeft: '-60px'}}>
                        <FormControl>
                            <RadioGroup
                                sx={{ display: 'flow-root' }}
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group" onChange={(e)=>{setUpdateKey(parseInt(e.target.value))}}>
                                <FormControlLabel checked={updateKey === 0} value={0} name="vegNonVeg"  className="mr-4" control={<Radio size='small' />} label="Save This Only" />
                                <br/>
                                <FormControlLabel checked={updateKey === 1} value={1} name="vegNonVeg" control={<Radio size='small' />} label="Save All" />
                            </RadioGroup>
                        </FormControl>
                    </div>
                </Modal.Body>
                <Modal.Footer className='mt-2'>
                    <button type="button" className="btn btn-danger redButton mr-3" onClick={()=> {setUpdateKey(0); setShowModal(false)}}>
                        Cancel</button>
                    <button type="button" className="btn btn-success greenButton " onClick={()=>{handleUpdate(updateKey)}}>
                        Ok</button>
                </Modal.Footer>
            </Modal>
    )
}

export const AlertModal = ({showModal, setShowModal, onOk}) =>{
    return (
        <Modal centered className="edit-activity-modal br-8" show={showModal} onHide={() => { setShowModal(false) }}>
                <Modal.Header className='w-100'>
                    <div className='d-flex position-relative justify-content-center w-100'>
                        <div className="modalText pb-4">Are you sure?</div>
                        <div className="cross--icon position-absolute" style={{right: '15px'}} onClick={() => { setShowModal(false) }}><img src={CrossIcon}/></div>
                    </div>
                </Modal.Header>
                <Modal.Body className='pt-2 float-start'>
                    <div className="">
                        <label htmlFor="exampleFormControlInput1" className="form-label DeleteDesc-guest">This wil remove all booked activities after the selected end date.</label>
                    </div>
                </Modal.Body>
                <Modal.Footer className='mt-2'>
                    <button type="button" className="btn btn-success greenButton " onClick={()=>{onOk(); setShowModal(false)}}>
                        Ok</button>
                    <button type="button" className="btn btn-danger redButton mr-3" onClick={()=> {setShowModal(false)}}>
                        Cancel</button>
                </Modal.Footer>
            </Modal>
    )
}